import Image from 'next/image'

const Bookings = ({ t }) => {
  return (
    <>
      <h3 className='font-light text-[30px] md:text-[28px] my-6'>{t('bookings.title')}</h3>
      <p className='font-normal mb-6'>{t.rich('bookings.makeBooking')}</p>
      <p className='font-light mb-6'>
        {t.rich('bookings.selectBookings', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-booking-transfer-1.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('bookings.enteraddresses', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_05.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('bookings.clickBook', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_06.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.enterPassengerInfo', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_07.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.enterairport', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_08.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-1 leading-[1.5]'>
        {t.rich('bookings.commericalFlightStep', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <p className='font-light mb-1 leading-[1.5]'>
        {t.rich('bookings.privateFlightStep', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <p className='font-light mb-1 leading-[1.5]'>
        {t.rich('bookings.trainNumberStep', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <p className=' mb-6 font-light leading-[1.5]'>
        {t.rich('bookings.reviewBooking')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_09.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-1 leading-[1.5]'>
        {t.rich('bookings.choosePaymentMethod', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_10.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>{t('bookings.makeBookingBTH')}</p>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.bth-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-booking-bythehour-2.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.bth-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_12.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.bth-step-3', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_13.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.bth-step-4')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_14.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.bth-step-5')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_20.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.bth-step-6')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_21.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.bth-step-7', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_22.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      {/* <p className='font-normal mb-6'>{t('bookings.makeBookingCarRental')}</p> */}
      {/* <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.carRental-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p> */}
      {/* <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-booking-carrental-3.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div> */}
      {/* <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.carRental-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p> */}
      {/* <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_24.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.carRental-step-3', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_25.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.carRental-step-4')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_26.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.carRental-step-5')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_27.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.carRental-step-6', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_28.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.carRental-step-7')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_29.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.carRental-step-8')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_30.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.carRental-step-9', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p> */}
      {/* <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_31.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div> */}
      <p className='font-normal mb-6'>
        {t.rich('bookings.find-booking-details')}
      </p>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.find-booking-details-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>
        {t('bookings.download-booking-confirmation')}
      </p>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.download-booking-confirmation-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.download-booking-confirmation-step-2')}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_33.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>{t('bookings.make-changes-booking')}</p>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.make-changes-booking-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.make-changes-booking-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_34.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>{t('bookings.cancel-booking')}</p>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.cancel-booking-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.cancel-booking-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_35.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>
        {t('bookings.view-chauffeur’s-details')}
      </p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.view-chauffeur’s-details-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.view-chauffeur’s-details-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_36.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('bookings.share-booking-team')}</p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.share-booking-team-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.share-booking-team-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image066.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.share-booking-team-step-3', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image068.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('bookings.remove-team-member')}</p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.remove-team-member-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_32.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.remove-team-member-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image070.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.remove-team-member-step-3', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image068.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('bookings.follow-booking')}</p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.follow-booking-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image073.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.follow-booking-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image075.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('bookings.unfollow-booking')}</p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.unfollow-booking-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image073.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.unfollow-booking-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image078.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <div className='mb-6'>
        <p className='font-normal mb-6'>{t('bookings.notifications.title')}</p>
        <p className='font-light mb-6 leading-[1.5]'>
          {t('bookings.notifications.description')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.1')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.2')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.3')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.4')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.5')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.6')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.7')}
        </p>
        <p className='font-light leading-[1.5]'>
          {t('bookings.notifications.types.8')}
        </p>
      </div>

      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-notifications-4.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>
        {t('bookings.enter-a-company-case-ID')}
      </p>

      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.enter-a-company-case-ID-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>

      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/images/website-updates/faq-internal-id-5.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6 leading-[1.5]'>
        {t.rich('bookings.enter-a-company-case-ID-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>

      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image084.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.enter-a-company-case-ID-step-3')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image086.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-light mb-6 leading-[1.5]'>
        {t('bookings.enter-a-company-case-ID-step-4')}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image088.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image090.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image092.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
    </>
  )
}

export default Bookings
